module.exports = __webpack_public_path__ + "static/img/images_ID003.370544a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_course/images_ID003.jpg
// module id = HHgA
// module chunks = 0